import Oboe from 'oboe/dist/oboe-browser';

import { getBootstrap } from '@client/app/bootstrap';

const { API } = getBootstrap();

export const PusherService = {
  streamParent(endpoint, payload, pattern = '{_id}') {
    const { token } = getBootstrap();

    return Oboe({
      method: 'POST',
      url: `${API}/rest/domain/execute/stream${endpoint}`,
      body: payload,
      headers: {
        Authorization: `Bearer ${token}`
      },
      pattern,
      useXDomain: true,
      withCredentials: true
    });
  }
};
